
import { LegacyExportService } from "@directives/_veri/export/legacyExport.service";
import { EventAction } from "@directives/_vehicle/journeySummary/journeySummary.component";
import { IVeriListRow } from "@directives/_veri/veriList/veriList.component";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { PlotReasonFilter } from "@enums/PlotReasonFilter";
import { ReasonCode } from "@enums/ReasonCode";
import { IComboBox } from "@interfaces/IComboBox";
import { IJourney } from "@interfaces/IJourney";
import { IPlot, IPlotEvent } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import { ConstantsService } from "@services/constantsService";
import { IHistoricalDay } from "@services/journey.service";
import * as angular from "angular";
import * as moment from "moment";
import "./vehicleHistory.scss";

export enum VehicleHistoryPage {
    Journeys,
    Plots,
    Events
}

interface IVehicleHistoryComponentBindings {
    loading: boolean;
    vehicle: IVehicle;
    historicalDay: IHistoricalDay;
    selectedPlot: IPlot;
    selectedPlotEvent: IPlotEvent;
    hideJourneySummary: boolean;

    onPlotsFiltered: (args: { plots: IPlot[] }) => void;
    onMouseEvent: (args: { plot: IPlot, journey: IJourney, event: IPlotEvent, eventAction: EventAction }) => void;
    onViewChanged: (args: { viewState: VehicleHistoryPage }) => void;
    onRequestVideoClick: (args: { requestTime: moment.Moment, $event: MouseEvent }) => void;
}

class VehicleHistoryComponentController implements angular.IComponentController, IVehicleHistoryComponentBindings {

    // bindings
    loading = false;
    vehicle: IVehicle;
    historicalDay: IHistoricalDay;
    selectedPlot: IPlot;
    selectedPlotEvent: IPlotEvent;

    onMouseEvent: (args: { plot: IPlot, journey: IJourney, event: IPlotEvent, eventAction: EventAction }) => void;
    onViewChanged: (args: { viewState: VehicleHistoryPage }) => void;
    onPlotsFiltered: (args: { plots: IPlot[] }) => void;
    onRequestVideoClick: (args: { requestTime: moment.Moment, $event: MouseEvent }) => void;

    // other
    reverseJourneys = true;
    hideJourneySummary: boolean;
    selectedJourney: IJourney;

    historicalPlotRows: IVeriListRow<IPlot>[] = [];
    plotFilterTypes: IComboBox[] = [];
    highlightedPlot: IPlot;
    lastMouseEvent: MouseEvent;
    currentViewState: VehicleHistoryPage = VehicleHistoryPage.Journeys;
    viewStates = VehicleHistoryPage;
    isMobile: boolean;

    static $inject = ["$scope", "exportService", "constantsService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly exportService: LegacyExportService,
        private readonly constantsService: ConstantsService) {
    }

    $onInit() {
        this.isMobile = this.constantsService.getIsMobile();

        //this.plotFilterTypes.push({ Name: "All Types", Value: PlotReasonFilter.All });
        this.plotFilterTypes.push({ Name: "Accelerometer", Value: PlotReasonFilter.Accelerometer });
        this.plotFilterTypes.push({ Name: "FMS", Value: PlotReasonFilter.FMS });
        this.plotFilterTypes.push({ Name: "Ignition", Value: PlotReasonFilter.Ignition });
        //this.plotFilterTypes.push({ Name: "Telematics", Value: PlotReasonFilter.Telematics });
        this.plotFilterTypes.push({ Name: "Temperature", Value: PlotReasonFilter.Temperature });
        this.plotFilterTypes.push({ Name: "Travel", Value: PlotReasonFilter.Travel });
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.createHistoricalPlotRows();
    }

    onJourneyEventAction(journey: IJourney, event: IPlotEvent, eventAction: EventAction, mouseEvent: MouseEvent) {
        //if (!event || !event.plot) {
        //    return;
        //}        

        this.highlightPlot(event && event.plot, mouseEvent);

        this.mouseEvent(journey, event, null, eventAction);
    }

    mouseEvent(journey: IJourney, event: IPlotEvent, plot: IPlot, eventAction: EventAction) {
        if (!this.onMouseEvent) {
            return;
        }

        this.onMouseEvent({ journey: journey, event: event, plot: plot, eventAction: eventAction });
    }

    highlightJourney(journey: IJourney) {
        this.mouseEvent(journey, null, null, EventAction.Hover);
    }

    plotListMouseLeave() {
        this.mouseEvent(null, null, null, EventAction.Hover);
    }

    plotHover(plot: IPlot, mouseEvent: MouseEvent) {

        this.highlightPlot(plot, mouseEvent);
        this.mouseEvent(null, null, plot, EventAction.Hover);
    }

    plotClicked(plot: IPlot) {
        this.mouseEvent(null, null, plot, EventAction.Selected);
    }

    journeyHover(journey: IJourney) {
        this.mouseEvent(journey, null, null, EventAction.Hover);
    }

    journeyClicked(journey: IJourney) {
        if (this.selectedJourney == journey) {
            this.selectedJourney = null;
        }
        else {
            this.selectedJourney = journey;
        }

        this.mouseEvent(this.selectedJourney, null, null, EventAction.Selected);
    }

    plotHistoryUpdated(rows: IVeriListRow<IPlot>[]) {

        var displayPlots: IPlot[] = [];

        rows.forEach(row => {
            displayPlots.push(row.data);
        })

        if (this.onPlotsFiltered) {
            this.onPlotsFiltered({ plots: displayPlots });
        }
    }

    requestVideoClicked(time: moment.Moment, $event: MouseEvent) {
        if (this.onRequestVideoClick) {
            this.onRequestVideoClick({ requestTime: time, $event: $event });
        }

        this.$scope.$broadcast(BroadcastEvent.hidePopup);
    }

    exportData($event: MouseEvent): void {
        if (!this.historicalDay) {
            return;
        }
        switch (this.currentViewState) {
            case VehicleHistoryPage.Plots:
                this.exportService.showExportPlotsDialog(this.historicalDay.plots, $event, this.vehicle);
                break;
            case VehicleHistoryPage.Journeys:
                this.exportService.showExportJourneysDialog(this.historicalDay.journeyModel.journeys, $event, this.vehicle);
                break;
            case VehicleHistoryPage.Events:
                this.exportService.showExportEventsDialog(this.historicalDay.events, $event);
                break;
        }
    }

    viewChanged(viewState: VehicleHistoryPage) {
        this.currentViewState = viewState;

        if (this.onViewChanged) {
            this.onViewChanged({ viewState: viewState });
        }
    }

    // Not currently used
    //orderJourneys() {
    //    this.reverseJourneys = !this.reverseJourneys;
    //    this.journeyModel.journeys = this.$filter("orderBy")(this.journeyModel.journeys, "StartUtc", this.reverseJourneys);
    //}

    // --------------------------

    private highlightPlot(plot: IPlot, mouseEvent: MouseEvent) {

        this.lastMouseEvent = mouseEvent;
        if (plot) {
            this.highlightedPlot = plot;
        }
    }

    private createHistoricalPlotRows() {
        if (!this.historicalDay || !this.historicalDay.plots) {
            return;
        }

        this.historicalPlotRows = [];
        this.historicalDay.plots.forEach(plot => {
            this.historicalPlotRows.push({
                id: plot.Id,
                contents: plot?.LocationInformation?.LocationDescription,
                data: plot,
                sortData: plot.Utc,
                filterData: [this.plotReasonFilter(plot)]
            });
        });
    }

    private plotReasonFilter(plot: IPlot): PlotReasonFilter {
        switch (plot.Reason) {
            case ReasonCode.IgnitionOn:
            case ReasonCode.IgnitionOff:
                return PlotReasonFilter.Ignition;

            case ReasonCode.Fms:
            case ReasonCode.FmsOff:
            case ReasonCode.FmsOn:
                return PlotReasonFilter.FMS;

            //case ReasonCode.Telematics:
            //    return PlotReasonFilter.Telematics;

            case ReasonCode.Temperature:
                return PlotReasonFilter.Temperature;

            case ReasonCode.TravelPlot:
            case ReasonCode.TravelStart:
            case ReasonCode.TravelStop:
            case ReasonCode.TravelPlot2:
                return PlotReasonFilter.Travel;

            case ReasonCode.Accelerometer:
                return PlotReasonFilter.Accelerometer;

            default:
                return PlotReasonFilter.Other;
        }
    }
}

export class VehicleHistoryComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            loading: "<",
            vehicle: "<",
            historicalDay: "<",
            selectedPlot: "<",
            selectedPlotEvent: "<",
            hideJourneySummary: "<",

            onPlotsFiltered: "&",
            onMouseEvent: "&",
            onViewChanged: "&",
            onRequestVideoClick: "&"
        };

        this.controller = VehicleHistoryComponentController;
        this.template = require("./vehicleHistory.html");
    }
}
